import React from "react";
import { Row, Col, InputNumber, Switch } from "antd";

const SectionHeader = () => (
  <Row gutter={16} className="mb-2">
    <Col span={10} />
    <Col span={4} className="text-center">
      <span className="text-muted small">偵測啟動</span>
    </Col>
    <Col span={10} />
  </Row>
);

const EnableRow = ({ label, description, enabledKey, fields, setField }) => (
  <Row gutter={16} className="mb-2 align-items-center">
    <Col span={10}>
      <label className="font-weight-bold">{label}</label>
      {description && <div className="text-muted small">{description}</div>}
    </Col>
    <Col span={4} className="text-center">
      <Switch
        checked={fields[enabledKey]}
        onChange={(v) => setField(enabledKey, v)}
      />
    </Col>
    <Col span={10} />
  </Row>
);

const FieldRow = ({
  label,
  description,
  fieldKey,
  min,
  max,
  step,
  unit,
  fields,
  setField,
}) => (
  <Row gutter={16} className="mb-2 align-items-center">
    <Col span={10}>
      <label>{label}</label>
      {description && <div className="text-muted small">{description}</div>}
    </Col>
    <Col span={4} />
    <Col span={10}>
      <InputNumber
        style={{ width: "100%" }}
        min={min}
        max={max}
        step={step}
        value={fields[fieldKey]}
        onChange={(v) => setField(fieldKey, v)}
        addonAfter={unit}
      />
    </Col>
  </Row>
);

const EquipmentConfig = ({ fields, setField }) => (
  <div className="pt-2">
    <SectionHeader />

    <EnableRow
      label="機具鄰近偵測"
      description="未授權人員接近機具時觸發警報"
      enabledKey="equipment_proximity_enabled"
      fields={fields}
      setField={setField}
    />
    <FieldRow
      label="警報冷卻時間"
      description="同一人員同一機具的重複警報間隔"
      fieldKey="equipment_proximity_cooldown_seconds"
      min={60}
      max={86400}
      step={60}
      unit="秒"
      fields={fields}
      setField={setField}
    />
    <EnableRow
      label="現場蜂鳴器連動"
      description="警報成立時發佈 MQTT 訊息，觸發現場警示燈號與蜂鳴器"
      enabledKey="equipment_buzzer_enabled"
      fields={fields}
      setField={setField}
    />

    <div className="text-muted small">機具電量警報沿用「電量」分頁設定。</div>
  </div>
);

export default EquipmentConfig;
